var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatchloadExperiment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7362 0.636353H6.58677V3.61156H14.7362V0.636353ZM33.3636 27.4132H30.3884V19.2637H33.3636V27.4132ZM33.3636 18.0995H30.3884V9.95004H33.3636V18.0995ZM33.3636 8.78583H30.3884V3.61156H25.2141V0.636353H33.3636V8.78583ZM24.0499 0.636353V3.61156H15.9005V0.636353H24.0499ZM2.12396 5.09916H10.2734V8.07437H2.12396V5.09916ZM25.9256 31.876H28.9008V23.7265H25.9256V31.876ZM25.9256 22.5623H28.9008V14.4129H25.9256V22.5623ZM25.9256 13.2486H28.9008V5.09916H20.7513V8.07437H25.9256V13.2486ZM19.5871 8.07437V5.09916H11.4376V8.07437H19.5871ZM7.88033 9.56197H0.636353V16.806H7.88033V9.56197ZM16.1592 9.56197H8.91519V16.806H16.1592V9.56197ZM17.194 9.56197H24.438V16.806H17.194V9.56197ZM7.88033 17.8408H0.636353V25.0848H7.88033V17.8408ZM8.91519 17.8408H16.1592V25.0848H8.91519V17.8408ZM24.438 17.8408H17.194V25.0848H24.438V17.8408ZM0.636353 26.1196H7.88033V33.3636H0.636353V26.1196ZM16.1592 26.1196H8.91519V33.3636H16.1592V26.1196ZM17.194 26.1196H24.438V33.3636H17.194V26.1196Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchloadExperiment);
export default __webpack_public_path__ + "static/media/BatchloadExperiment.4986716a06e3ed95354cc9e0f116ee9c.svg";
export { ForwardRef as ReactComponent };